window.addEventListener("load", function(){
 let checkLig = window.localStorage.getItem("status");
  if(checkLig  === "fail"){
    document.querySelector(".product-form__submit").disabled = true;
  }
})



$(document).ready(function() {
  var $slider = $('.testimonial_slider');
  var $progressBar = $('.progress');
  var $progressBarLabel = $('.slider__label');
   $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    $progressBarLabel.text( calc + '% completed' );
  });
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 400,
    arrows: true,
  	prevArrow:"<button type='button' class='testimonial_arrow prev'><img src='https://cdn.prod.website-files.com/67b11ac4eca50e5956301fe4/67cfdb1260d82f0fbc5dd26e_Vector%20(10).svg'>",
    nextArrow:"<button type='button' class='testimonial_arrow nxt'><img src='https://cdn.prod.website-files.com/67b11ac4eca50e5956301fe4/67cfdb1260d82f0fbc5dd26e_Vector%20(10).svg'>"
  });  
});